export const RATIO_CODE = {
  STANDARD_LOANS: 'NB66',
  SPECIAL_MENTION_LOANS: 'NB67',
  SUB_STARDARD_LOANS: 'NB68',
  DOUBFUL_LOANS: 'NB69',
  LOSS_LOANS: 'NB70',
  NPL_RATIO: 'FA146',
  SPECIAL_MENTION_AND_NPL: 'FA147',
  SHORT_TERM_LOANS: 'NB72',
  MEDIUM_TERM_LOANS: 'NB73',
  LONG_TERM_LOANS: 'NB74',
  LOAN_LOASS_TO_NPL: 'FA148',
  LOAN_LOASS_TO_TOTAL_LOANS: 'RT0238',
}

export const TREND_QUALITY_DATA = [
  { value: RATIO_CODE.STANDARD_LOANS, color: '#006AA6', isBarChart: true },
  {
    value: RATIO_CODE.SPECIAL_MENTION_LOANS,
    color: '#C3D785',
    isBarChart: true,
  },
  { value: RATIO_CODE.SUB_STARDARD_LOANS, color: '#E3A2A7', isBarChart: true },
  { value: RATIO_CODE.DOUBFUL_LOANS, color: '#AE93E1', isBarChart: true },
  { value: RATIO_CODE.LOSS_LOANS, color: '#F5CBA3', isBarChart: true },
  { value: RATIO_CODE.NPL_RATIO, color: '#E6964C', isLineChart: true },
  {
    value: RATIO_CODE.SPECIAL_MENTION_AND_NPL,
    color: '#D96383',
    isLineChart: true,
  },
]

export const TERM_DATA = [
  { value: RATIO_CODE.SHORT_TERM_LOANS, color: '#006AA6' },
  { value: RATIO_CODE.MEDIUM_TERM_LOANS, color: '#FFCD60' },
  { value: RATIO_CODE.LONG_TERM_LOANS, color: '#74B49A' },
]

export const SECTOR_CODES = [
  'NB38',
  'NB39',
  'NB40',
  'NB45',
  'NB46',
  'NB55',
  'NB58',
  'NB61',
  'NB62',
  'NB63',
  'NB64',
]
